import React from "react";

import Login from "Pages/Login";

import HeaderLogin from "Components/Shared/HeaderLogin";
import ForgotPassword from "Pages/ForgotPassword";
import PasswordRecovery from "Pages/PasswordRecover";

export default [
  {
    component: Login,
    path: "/login",
    header: <HeaderLogin />,
    footer: false,
    exact: true,
  },
  {
    component: Login,
    path: "/",
    header: <HeaderLogin />,
    footer: false,
    exact: true,
  },
  {
    component: ForgotPassword,
    path: "/esqueci-senha",
    header: <HeaderLogin />,
    footer: false,
    exact: true,
  },
  {
    component: PasswordRecovery,
    path: "/recuperar-senha",
    header: <HeaderLogin />,
    footer: false,
    exact: true,
  },
];
